<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="pageTitle">
          <template v-slot:toolbar>
            <div class="row">
              <div class="ml-3">
                <button
                  type="button"
                  class="btn btn-secondary font-weight-bolder btn-sm"
                  @click="goBack"
                >
                  <i style="font-size: 1rem" class="flaticon2-left-arrow"></i
                  >Quay lại
                </button>
              </div>
            </div>
          </template>
          <template v-slot:preview>
            <!-- Dùng CHUNG thân với modal, không nhân bản giao diện (NT-3) -->
            <ReportDetailBody
              :on-loading="onLoading"
              :overview="overview"
              :period="period"
              :store="store"
              :department-name="departmentName"
              :adjustments="adjustments"
              :category-groups="categoryGroups"
              :bill-query="billQuery"
            />
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import { makeToastFaile } from '@/utils/common';
import {
  COMMISSION_REPORT_TYPE_NAME,
} from './commission.constants';
import commissionReportMixin from './commissionReport.mixin';
import ReportDetailBody from './ReportDetailBody.vue';

export default {
  components: {
    KTCodePreview,
    ReportDetailBody,
  },
  mixins: [commissionReportMixin],
  data() {
    return {
      onLoading: false,

      overview: null,
      period: null,
      store: null,
      departmentName: '',
      adjustments: [],
      categoryGroups: [],
      billQuery: null,

    };
  },
  computed: {
    pageTitle() {
      const base =
        COMMISSION_REPORT_TYPE_NAME[this.reportType] || 'Báo cáo hoa hồng';
      return `Chi tiết hoa hồng nhân viên — ${base}`;
    },
    employeeLabel() {
      if (!this.overview) {
        return '';
      }
      return this.overview.employeeCode
        ? `${this.overview.employeeName} (${this.overview.employeeCode})`
        : this.overview.employeeName || '--';
    },
    scopeName() {
      return this.displayScopeName({
        store: this.store,
        departmentName: this.departmentName,
      });
    },
  },
  watch: {
    '$route.query': function () {
      this.resolveReportType();
      this.setBreadcrumb();
      this.fetchDetail();
    },
  },
  created() {
    this.resolveReportType();
    this.setBreadcrumb();
    this.fetchDetail();
  },
  methods: {
    setBreadcrumb() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Hoa hồng V2' },
        {
          title: COMMISSION_REPORT_TYPE_NAME[this.reportType] || 'Báo cáo',
          route: { name: this.reportRouteName(), query: this.backQuery() },
        },
        { title: 'Chi tiết nhân viên' },
      ]);
    },
    /**
     * Query để quay lại màn tổng hợp — mang theo NGUYÊN bộ lọc đã dùng.
     * Nếu chỉ trả về `type` thì bấm Quay lại sẽ ra màn trống, người dùng
     * phải chọn lại kỳ và cửa hàng từ đầu.
     * Ngày ở URL màn tổng hợp là DD/MM/YYYY, còn ở đây là YYYY-MM-DD -> đổi lại.
     */
    backQuery() {
      const query = this.$route.query || {};
      const back = {};
      if (query.fromDate) {
        back.fromDate = this.toInputDate(query.fromDate);
      }
      if (query.toDate) {
        back.toDate = this.toInputDate(query.toDate);
      }
      if (query.storeId) {
        back.storeId = query.storeId;
      }
      if (query.departmentId) {
        back.departmentId = query.departmentId;
      }
      return back;
    },
    goBack() {
      this.$router.push({
        name: this.reportRouteName(),
        query: this.backQuery(),
      });
    },

    /* ------------------------------ Hóa đơn ------------------------------ */
    billRowClass(item) {
      return item && this.isMinusRow(item) ? 'table-danger-soft' : '';
    },

    /* ---------------------------- Tải dữ liệu ---------------------------- */
    fetchDetail() {
      const query = this.$route.query || {};
      if (!query.employeeId || !query.fromDate || !query.toDate) {
        makeToastFaile('Thiếu thông tin nhân viên hoặc kỳ báo cáo!');
        return;
      }

      this.onLoading = true;
      const params = {
        type: this.reportType,
        employeeId: query.employeeId,
        fromDate: query.fromDate,
        toDate: query.toDate,
      };
      if (query.storeId) {
        params.storeId = query.storeId;
      }
      if (query.departmentId) {
        params.departmentId = query.departmentId;
      }
      // Bảng hoá đơn tự gọi API riêng có phân trang (§7.5 #3)
      this.billQuery = { ...params };

      ApiService.setHeader();
      ApiService.query('commission-reports/details', { params })
        .then(({ data }) => {
          const result = data.data || {};
          this.overview = result.overview || null;
          this.period = result.period || null;
          this.store = result.store || null;
          this.departmentName = result.departmentName || '';
          // API đã trả sẵn operatorName; ReportDetailBody cũng có fallback riêng
          this.adjustments = result.adjustments || [];
          this.categoryGroups = result.categoryGroups || [];
          // Mở sẵn nhóm đầu tiên cho dễ đọc
          this.openGroupIds = this.categoryGroups.length
            ? [this.categoryGroups[0].commissionCategoryId]
            : [];
        })
        .catch((error) => {
          this.overview = null;
          this.adjustments = [];
          this.categoryGroups = [];
          this.billQuery = null;
          makeToastFaile(
            this.getErrorMessage(
              error,
              'Không tải được chi tiết hoa hồng của nhân viên!',
            ),
          );
        })
        .finally(() => {
          this.onLoading = false;
        });
    },
  },
};
</script>

<style scoped>
/* Trang chỉ còn khung + nút Quay lại; toàn bộ bảng nằm trong ReportDetailBody */
</style>
